import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.loading = false
    this.loadNextPage = this.loadNextPage.bind(this)
    window.addEventListener("scroll", this.loadNextPage)
    this.loadNextPage()
  }

  disconnect() {
    window.removeEventListener("scroll", this.loadNextPage)
  }

  loadNextPage() {
    const nextPageLink = this.element.querySelector(".pagination .next_page[href]")

    if (!nextPageLink || this.loading || !this.nearBottom()) {
      return
    }

    this.loading = true
    this.setPaginationText("Ielādējas vairāk rezultāti...")

    fetch(nextPageLink.href, { headers: { Accept: "text/html" } })
      .then((response) => response.text())
      .then((html) => this.appendPage(html))
      .finally(() => {
        this.loading = false
      })
  }

  nearBottom() {
    return window.scrollY + window.innerHeight > document.documentElement.scrollHeight - 50
  }

  appendPage(html) {
    const page = new DOMParser().parseFromString(html, "text/html")
    const suggestions = this.element.querySelector("#suggestions")
    const nextSuggestions = page.querySelectorAll("#suggestions > *")
    const pagination = this.element.querySelector(".pagination")
    const nextPagination = page.querySelector(".pagination")

    nextSuggestions.forEach((suggestion) => suggestions.appendChild(suggestion))

    if (pagination && nextPagination) {
      pagination.replaceWith(nextPagination)
    } else if (pagination) {
      pagination.remove()
    }
  }

  setPaginationText(text) {
    const pagination = this.element.querySelector(".pagination")

    if (pagination) {
      pagination.textContent = text
    }
  }
}
